import { Provider } from '@angular/core';
import { environment } from 'src/environments/environment';

import { PaymentsDashboardRepository } from '@app/domain/ports/payments-dashboard.repository';
import { PaymentsDashboardRemoteDataSource } from '@app/data/data-sources/remote/payments-dashboard-remote.data-source';
import { PaymentsDashboardMockDataSource } from '@app/data/data-sources/mock/payments-dashboard-mock.data-source';

/**
 * Port del dashboard de pagos con toggle mock/remote
 * (`environment.paymentsDashboardUseMocks`; ausente = remoto).
 *
 * Recibe el booleano para que su spec pruebe las dos ramas sin tocar `environment`
 * (mismo patrón que `providePaymentQrRepository`).
 */
export function providePaymentsDashboardRepository(useMocks: boolean): Provider {
  return {
    provide: PaymentsDashboardRepository,
    useClass: useMocks ? PaymentsDashboardMockDataSource : PaymentsDashboardRemoteDataSource,
  };
}

/**
 * Se registra en ROOT (`app.config.ts`): lo consume también
 * `GlobalDashboardRemoteDataSource` ("Todo"), que es root — mismo caso que
 * `TPV_REST_PROVIDERS`.
 */
export const PAYMENTS_DASHBOARD_PROVIDERS: Provider[] = [
  providePaymentsDashboardRepository(environment.paymentsDashboardUseMocks === true),
];
